import { isExistFeatureFlag } from '@/service/feature/isExistFeatureFlag';
import { isBetaFacility } from '@/service/facility/isBetaFacility';
import {
  ContactToScheduleApplyTargetFacility,
  isContactToScheduleApplyTarget,
} from '@/service/parentContacts/isContactToScheduleApplyTarget';
import { isContactToScheduleApplyRolloutPublic } from '@/service/parentContacts/isContactToScheduleApplyRolloutPublic';

const FEATURE_KEY = 'useContactV3Api';

export const isContactToScheduleApplyEnabled = async (
  services?: ContactToScheduleApplyTargetFacility
): Promise<boolean> => {
  if (!isContactToScheduleApplyTarget(services)) {
    return false;
  }

  if (await isContactToScheduleApplyRolloutPublic()) {
    return true;
  }

  const [hasFlag, isBeta] = await Promise.all([isExistFeatureFlag(FEATURE_KEY), isBetaFacility(FEATURE_KEY)]);
  return hasFlag && isBeta;
};
